module.exports = __webpack_public_path__ + "img/mainfunction.e004ece1.png";